module.exports = __webpack_public_path__ + "static/img/mb_left.853f5968.png";